/**
 * i18n 工具函数
 * 统一处理平台名称（WeTV/iflix）的替换
 */

import i18n from '@/i18n/config';
import { getPlatformName } from './platformUtils';

/**
 * 扩展的 i18n.t 函数，自动注入平台名称
 * @param key 翻译 key
 * @param options 翻译参数，如果包含 WeTV 占位符会自动替换为当前平台名称
 * @returns 翻译后的字符串
 *
 * @example
 * // 基础用法
 * t('vipOpenPage.dear') // 自动注入 WeTV: getPlatformName()
 *
 * // 带其他参数
 * t('vipOpenPage.welcome', { username: 'John' })
 *
 * // 手动覆盖平台名称
 * t('vipOpenPage.dear', { WeTV: 'Custom Platform' })
 */
export function t(key: string, options?: Record<string, string>): string {
  // 合并默认的 WeTV 参数
  const params = {
    WeTV: getPlatformName(),
    ...options, // 用户传入的参数可以覆盖默认值
  };

  return i18n.t(key, params);
}

/**
 * 检查翻译 key 是否存在
 * @param key 翻译 key
 * @returns 是否存在
 */
export function hasTranslation(key: string): boolean {
  return i18n.exists(key);
}

/**
 * 切换语言
 * @param language 语言代码
 */
export async function changeLanguage(language: string): Promise<any> {
  // 切换语言
  return await i18n.changeLanguage(language);
}

/**
 * 获取当前语言
 */
export function getCurrentLanguage(): string {
  return i18n.language;
}
